/* FitMiss funnel — page behaviour.
 *
 * SOURCE OF TRUTH: fitmiss-site/assets/fitmiss-funnel.js in git. Deployed to the
 * live theme as assets/fitmiss-funnel.js and loaded from page.fitmiss-funnel.liquid
 * with `{{ 'fitmiss-funnel.js' | asset_url }}` + defer. NEVER hand-edit it in
 * Shopify's code editor — the next push clobbers it (AGENTS.md golden rule 1).
 *
 * WHY IT IS HERE AND NOT INLINE (batch 82, 19 Sep 2026): the template was
 * 259,277 B against Shopify's 262,144 B ceiling, so every design decision had
 * become a byte negotiation. These four blocks left the template verbatim, in
 * their original order, and recovered ~24 KB.
 *
 * WHAT STAYED INLINE, deliberately:
 *   - the `js` class one-liner (must run before first paint);
 *   - the `fmConsent` gate and the three trackers it gates (they must run in
 *     the head, before anything can fire, and the tracking freeze covers them);
 *   - ALL CSS. Moving it would trade 71 KB of template for a render-blocking
 *     request on a first-visit paid-traffic landing page, which is the wrong
 *     trade even though it is the bigger number.
 *
 * `toggleAccordion`, `toggleMobileMenu` and `handleEmailSubmit` are called from
 * inline on* attributes in the markup and MUST stay top-level declarations here.
 */

/* ==== trust marquee — pause control and the collapse-on-scroll bar ==== */
      (function () {
        var track = document.getElementById('trust-track');
        var pause = document.getElementById('trust-pause');
        if (track && pause) {
          var ICON_PAUSE = '<rect x="8.1" y="6" width="2.6" height="12" rx="1"/><rect x="13.3" y="6" width="2.6" height="12" rx="1"/>';
          var ICON_PLAY = '<path d="M9 5.5v13l10-6.5z"/>';
          pause.addEventListener('click', function () {
            var paused = track.classList.toggle('is-paused');
            pause.setAttribute('aria-pressed', paused ? 'true' : 'false');
            pause.setAttribute('aria-label', paused ? 'Resume the announcements' : 'Pause the announcements');
            pause.setAttribute('title', paused ? 'Play' : 'Pause');
            pause.querySelector('svg').innerHTML = paused ? ICON_PLAY : ICON_PAUSE;
          });
        }

        // Batch 133 (V4, operator + auditor 2026-10-10): the trust bar NO LONGER collapses on scroll on
        // phones. It was collapsing after 60 px, so most visitors never saw the guarantee or shipping lines
        // that the hero leaves to it ("the marquee is the single home for trust claims", 13 Sep).
      })();
    

/* ==== page behaviour — menu, accordions, sticky CTA, header, reveals, email capture, tracking ==== */
        function setMenuIcon(button) {
            var use = button.querySelector('use');
            var open = button.getAttribute('aria-expanded') === 'true';
            if (use) use.setAttribute('href', open ? '#i-x' : '#i-bars');
            var scrim = document.getElementById('menu-scrim');
            if (scrim) scrim.classList.toggle('on', open);
            var sticky = document.getElementById('sticky-cta');
            if (sticky) sticky.classList.toggle('menu-suppressed', open);
        }

        /* Batch 83 — the menu state, finished (design review 05/06/07). Three gaps, one
           piece of work, so all four close paths go through closeMenu():

           05  It had no transition. `hidden` is display:none, which cannot animate, so the
               panel was present on frame one while the scrim faded around it over 0.25 s —
               the only state change on the page that snapped. `hidden` still comes off first
               (and goes back on after) so the no-JS case is unchanged; `.menu-open` on the
               next frame drives opacity + an 8 px unfold from `transform-origin: top`, at the
               page's own 0.22 s / cubic-bezier(0.4, 0, 0.2, 1). The global
               prefers-reduced-motion block already flattens it to 0.001 ms.
           06  Nothing locked body scroll, and #mobile-menu is absolute on the nav rather than
               fixed — so a swipe scrolled the blurred page AND took the panel off screen,
               leaving a blur over nothing. position:fixed with a negative top is the version
               that holds on iOS Safari; plain overflow:hidden does not, and iOS is most of
               this traffic.
           07  No key handler existed anywhere in the page, so Escape did nothing and a
               keyboard user had to tab back to the corner. Escape now closes and returns
               focus to the toggle; opening moves focus to the first link. */
        /* Batch 93 — THE MENU OPENED OFF-SCREEN. The real defect, and the one batches 83
           and 90 both missed because both verified the CLOSE and never looked at the open
           panel anywhere except the top of the page.

           #header is `position: fixed`. Batch 83's scroll lock pinned the BODY
           (`position:fixed; top:-Npx`) — and a positioned body drags the fixed header with
           it. Measured live at scroll 1800: header top -1800, menu top -1696. The panel
           was opening 1800 px above the viewport. At scroll 0 it is invisible, which is
           where it was tested. Anywhere else the menu simply did not appear.

           The lock also answered a premise that was never true. The review that asked for
           it said "#mobile-menu is absolute on the nav, so the menu scrolls out of view".
           Measured with no lock at all: header top 0 and menu top 70 at scroll 1500 AND
           2600 — the panel lives inside a FIXED header and never moves. There was nothing
           to fix.

           So the body pin is gone, and with it batch 90's whole scroll-restore apparatus
           (no stored offset, no scrollTo, no forcing scroll-behavior to auto — none of it
           is needed if the page never moves). `overflow: hidden` on the ROOT stops the
           user's wheel/touch scroll without positioning anything, so nothing can shift.
           If iOS lets a swipe through, the page scrolls behind the scrim — the pre-83
           behaviour, cosmetic, and the menu still stays anchored under the header.

           The menu is `md:hidden`, so this only ever runs at mobile widths where there is
           no scrollbar to remove: no reflow when the root locks.

           Kept from batch 90 because those fixes were real: `menu-open` is the single
           source of truth (`hidden` lags 240 ms behind it and made the toggle dead in that
           window), the pending hide is cancelled on reopen, and the open path is
           synchronous so the state is never ambiguous for a frame. */
        var _menuHideTimer = null;

        function _menuEl() {
            return {
                menu: document.getElementById('mobile-menu'),
                button: document.querySelector('[aria-controls="mobile-menu"]')
            };
        }

        function menuIsOpen() {
            var menu = document.getElementById('mobile-menu');
            return !!menu && menu.classList.contains('menu-open');
        }

        function openMenu() {
            var el = _menuEl();
            if (!el.menu || !el.button) return;
            if (_menuHideTimer) { clearTimeout(_menuHideTimer); _menuHideTimer = null; }
            el.menu.classList.remove('hidden');
            void el.menu.offsetHeight;          /* force layout: a start state to animate from */
            el.menu.classList.add('menu-open'); /* synchronous, so menuIsOpen() is never stale */
            el.button.setAttribute('aria-expanded', 'true');
            setMenuIcon(el.button);
            document.documentElement.style.overflow = 'hidden';
            var first = el.menu.querySelector('a, button');
            if (first) first.focus({ preventScroll: true });
        }

        function closeMenu(returnFocus) {
            var el = _menuEl();
            if (!el.menu || !el.button) return;
            el.menu.classList.remove('menu-open');
            el.button.setAttribute('aria-expanded', 'false');
            setMenuIcon(el.button);
            document.documentElement.style.overflow = '';
            if (returnFocus) el.button.focus({ preventScroll: true });
            if (_menuHideTimer) clearTimeout(_menuHideTimer);
            _menuHideTimer = window.setTimeout(function () {
                _menuHideTimer = null;
                if (!el.menu.classList.contains('menu-open')) el.menu.classList.add('hidden');
            }, 240);
        }

        function toggleMobileMenu() {
            if (menuIsOpen()) closeMenu(false); else openMenu();
        }

        document.querySelectorAll('.mobile-nav-link').forEach(function (link) {
            link.addEventListener('click', function () { closeMenu(false); });
        });

        document.addEventListener('click', function (event) {
            var el = _menuEl();
            if (!el.menu || !el.button) return;
            if (!el.menu.contains(event.target) && !el.button.contains(event.target) && menuIsOpen()) {
                closeMenu(false);
            }
        });

        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape' && menuIsOpen()) closeMenu(true);
        });

        function toggleAccordion(id, group) {
            const content = document.getElementById(id);
            const icon = document.getElementById('icon-' + id);
            const isOpen = content.style.maxHeight && content.style.maxHeight !== '0px';

            const prefix = group === 'ingredients' ? 'ing-' : 'faq-';
            document.querySelectorAll(`[id^="${prefix}"]`).forEach(item => {
                if (item.id !== id && item.classList.contains('accordion-content')) {
                    item.style.maxHeight = '0px';
                    item.classList.remove('active');
                    const itemIcon = document.getElementById('icon-' + item.id);
                    if (itemIcon) {
                        itemIcon.classList.remove('rotate-180');
                        const wrap = itemIcon.closest('.acc-chev');
                        if (wrap) wrap.classList.remove('is-open');
                    }
                    const itemBtn = document.querySelector('[aria-controls="' + item.id + '"]');
                    if (itemBtn) itemBtn.setAttribute('aria-expanded', 'false');
                }
            });
            const btn = document.querySelector('[aria-controls="' + id + '"]');
            if (btn) btn.setAttribute('aria-expanded', String(!isOpen));

            if (isOpen) {
                content.style.maxHeight = '0px';
                content.classList.remove('active');
                if (icon) {
                    icon.classList.remove('rotate-180');
                    const wrap = icon.closest('.acc-chev');
                    if (wrap) wrap.classList.remove('is-open');
                }
            } else {
                content.style.maxHeight = content.scrollHeight + 'px';
                content.classList.add('active');
                if (icon) {
                    icon.classList.add('rotate-180');
                    const wrap = icon.closest('.acc-chev');
                    if (wrap) wrap.classList.add('is-open');
                }
            }
        }

        // Default-open (batch 72, DESIGN_DECISIONS.md): the first row of each
        // accordion group opens on load, so the app-access answer and the
        // creatine claim are readable without a tap. Goes through the click
        // path so chevron + aria state match a user-opened row; the engagement
        // listener is click-bound, so no expand_* event fires on load.
        ['faq-access', 'ing-1'].forEach(function (id) {
            const el = document.getElementById(id);
            if (el && !(el.style.maxHeight && el.style.maxHeight !== '0px')) {
                toggleAccordion(id, id.indexOf('ing-') === 0 ? 'ingredients' : 'faq');
            }
        });
        // Open rows are height-locked to the scrollHeight measured at open;
        // re-measure on resize so a reflow cannot clip a row left open.
        window.addEventListener('resize', function () {
            document.querySelectorAll('.accordion-content.active').forEach(function (el) {
                el.style.maxHeight = el.scrollHeight + 'px';
            });
        });

        // Scroll-triggered reveal (IntersectionObserver)
        (function() {
            const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            const els = document.querySelectorAll('.reveal');
            if (prefersReducedMotion || !('IntersectionObserver' in window)) {
                els.forEach(el => el.classList.add('in-view'));
                return;
            }
            const io = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('in-view');
                        io.unobserve(entry.target);
                    }
                });
            }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
            els.forEach(el => io.observe(el));
        })();

        let hasScrolledPastHero = false;
        let stickyTicking = false;
        /* Was a NON-passive scroll listener doing three getBoundingClientRect() reads
           per event. Non-passive means the browser waits on this before it will scroll,
           and the reads force layout — the likeliest source of scroll jank on a phone.
           Now passive, and coalesced to one read per frame. */
        function updateStickyCta() {
            stickyTicking = false;
            const hero = document.getElementById('hero');
            const stickyCta = document.getElementById('sticky-cta');
            const header = document.getElementById('header');

            if (hero && stickyCta) {
                const heroBottom = hero.getBoundingClientRect().bottom;
                // Suppress the bar wherever a full-size ask is already on screen.
                // #start (the closing offer) joined #pricing here — without it the
                // closing CTA and the sticky bar sit on the same screen making the
                // same request, which is the duplication this check exists to stop.
                let askInView = false;
                ['pricing', 'start'].forEach(function (id) {
                    const el = document.getElementById(id);
                    if (!el) return;
                    const r = el.getBoundingClientRect();
                    if (r.top < window.innerHeight * 0.4 && r.bottom > 0) askInView = true;
                });
                if (heroBottom < -200 && !askInView) {
                    stickyCta.classList.add('visible');
                    hasScrolledPastHero = true;
                } else {
                    stickyCta.classList.remove('visible');
                    hasScrolledPastHero = false;
                }
            }

            if (header) {
                if (window.scrollY > 12) {
                    header.classList.add('scrolled');
                } else {
                    header.classList.remove('scrolled');
                }
            }
        }
        document.addEventListener('scroll', function () {
            if (stickyTicking) return;
            stickyTicking = true;
            requestAnimationFrame(updateStickyCta);
        }, { passive: true });

        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function(e) {
                const href = this.getAttribute('href');
                if (!href || href === '#') { e.preventDefault(); return; }
                const target = document.querySelector(href);
                if (!target) return;
                e.preventDefault();
                target.scrollIntoView({ behavior: 'smooth' });
            });
        });

        function updateHeaderStyle() {
            const header = document.getElementById('header');
            if (!header) return;

            // Check if a dark section is currently visible directly under the header.
            // "Probe point" = a few pixels below the header's actual bottom edge.
            const headerBottom = header.getBoundingClientRect().bottom;
            const probe = headerBottom + 4;
            const darkSections = ['dashboard', 'guarantee'];
            let isOnDark = false;

            darkSections.forEach(sectionId => {
                const section = document.getElementById(sectionId);
                if (!section) return;
                const rect = section.getBoundingClientRect();
                // Dark mode only when the dark section is the one visible right under the header
                if (rect.top <= probe && rect.bottom > probe) {
                    isOnDark = true;
                }
            });

            if (isOnDark) {
                header.classList.add('on-dark');
            } else {
                header.classList.remove('on-dark');
            }
        }

        document.addEventListener('scroll', updateHeaderStyle, { passive: true });
        window.addEventListener('load', updateHeaderStyle);
        window.addEventListener('resize', updateHeaderStyle);

        // ============================================================
        // Email capture -> Klaviyo
        //
        // FILL THESE TWO IN. Until you do, the form politely says signup is
        // opening soon instead of pretending to work.
        //
        //   KLAVIYO_COMPANY_ID  Klaviyo > Settings > API keys > Public API key.
        //                       Six characters, safe to expose in client code.
        //   KLAVIYO_LIST_ID     Klaviyo > Audience > Lists & Segments > open the
        //                       list > Settings. Six characters.
        //
        // This uses Klaviyo's client-side subscriptions endpoint, which is the
        // one meant for public forms. It creates or updates the profile and
        // records consent. If double opt-in is enabled on the list, Klaviyo
        // sends the confirmation email; nothing extra is needed here.
        // ============================================================
        const KLAVIYO_COMPANY_ID = 'VMdxrd';  // public API key — safe in client code
        const KLAVIYO_LIST_ID    = 'TSwrSF';  // "Website Signups" — the welcome-flow trigger list

        function handleEmailSubmit(event) {
            event.preventDefault();

            const form       = event.target;
            const input      = form.querySelector('input[name="email"]');
            const button     = document.getElementById('email-submit');
            const successMsg = document.getElementById('email-success');
            const errorMsg   = document.getElementById('email-error');
            const errorText  = document.getElementById('email-error-text');
            const email      = input.value.trim();

            // HONEYPOT (2026-09-26). The hidden fm_website field is off-screen,
            // aria-hidden and tabindex -1, so no human and no screen reader ever
            // reaches it. A form bot fills every input it finds. Answer as if the
            // signup worked — telling a bot it was detected just teaches whoever
            // wrote it to stop filling that field. Nothing is sent to Klaviyo.
            const trap = form.querySelector('input[name="fm_website"]');
            if (trap && trap.value.trim() !== '') {
                successMsg.classList.remove('hidden');
                form.reset();
                return;
            }

            function fail(message) {
                errorText.textContent = message;
                errorMsg.classList.remove('hidden');
            }
            function resetButton() {
                button.disabled = false;
                button.style.opacity = '';
                button.textContent = 'Join the list';
            }

            successMsg.classList.add('hidden');
            errorMsg.classList.add('hidden');

            if (!KLAVIYO_COMPANY_ID || !KLAVIYO_LIST_ID) {
                console.warn('Klaviyo not configured. Set KLAVIYO_COMPANY_ID and KLAVIYO_LIST_ID. Email attempted:', email);
                fail('Signup is opening soon. Check back shortly.');
                return;
            }

            if (button.disabled) return;          // guard against a double tap
            button.disabled = true;
            button.style.opacity = '0.7';
            button.textContent = 'Joining\u2026';

            fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KLAVIYO_COMPANY_ID), {
                method: 'POST',
                headers: { 'content-type': 'application/json', 'revision': '2024-10-15' },
                body: JSON.stringify({
                    data: {
                        type: 'subscription',
                        attributes: {
                            custom_source: 'Landing page footer form',
                            profile: { data: { type: 'profile', attributes: { email: email } } }
                        },
                        relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST_ID } } }
                    }
                })
            })
            .then(function(res) {
                if (res.status === 202 || res.ok) {
                    form.classList.add('hidden');
                    successMsg.classList.remove('hidden');
                    if (window.fmTrack) window.fmTrack('email_signup', { content_name: 'Landing page email capture' });
                    return;
                }
                resetButton();
                fail(res.status === 429
                    ? 'Too many attempts just now. Please try again in a minute.'
                    : 'That did not go through. Please try again, or email hello@fitmiss.co.uk.');
                console.error('Klaviyo subscribe failed', res.status);
            })
            .catch(function(err) {
                resetButton();
                fail('That did not go through. Check your connection, or email hello@fitmiss.co.uk.');
                console.error('Klaviyo subscribe error', err);
            });
        }

        // ============================================================
        // Custom analytics events — fire to Meta Pixel + GA4 in parallel
        // ============================================================
        (function() {
            /* Was the consent wall actually required for THIS visitor? — added
               2026-10-03 on the auditor's recommendation.

               Viewport height says how bad the wall WOULD be; it does not say
               whether this visitor met one. A returning visitor with stored
               consent has the same 677px viewport and no wall at all, and
               averaging those two populations together hides the effect we are
               looking for.

               LABELS SAY ONLY WHAT THE API SAYS. These were first written as
               `wall_shown` / `no_wall_stored_consent`, which claims more than is
               known: shouldShowBanner() === false does not prove stored consent,
               and true does not prove a banner actually rendered — this estate
               has already had a case where Shopify said show and nothing
               appeared. So: `banner_required` / `banner_not_required`.

               Read from Shopify's own Customer Privacy API and held IN MEMORY
               ONLY. It is attached to events that fire later, all of which are
               already behind the analytics consent gate, so nothing is
               transmitted before consent — this is deliberately NOT a
               pre-consent beacon. Snapshotted as early as the API exists and
               never overwritten, because once consent is granted
               shouldShowBanner() flips to false and the answer would be lost.

               BOTH THIS AND THE VIEWPORT SNAPSHOT SIT OUTSIDE THE CONSENT GATE
               ON PURPOSE. They only READ — nothing leaves the browser here. If
               they sat inside, they would run at CONSENT time and would record
               the viewport when she accepted plus "not required" for everyone,
               which is the opposite of what they are for. Reading an API is not
               tracking; transmitting is, and that still happens only after the
               gate. */
            var BANNER_AT_LOAD = null;
            (function captureBannerState(tries) {
                if (BANNER_AT_LOAD !== null) return;
                try {
                    var cp = window.Shopify && window.Shopify.customerPrivacy;
                    if (cp && typeof cp.shouldShowBanner === 'function') {
                        BANNER_AT_LOAD = cp.shouldShowBanner() ? 'banner_required' : 'banner_not_required';
                        return;
                    }
                } catch (e) { /* API not ready */ }
                if ((tries || 0) < 50) setTimeout(function () { captureBannerState((tries || 0) + 1); }, 100);
            })(0);

            var INITIAL_VIEWPORT_BAND = (function () {
                var h = window.innerHeight || 0;
                if (h < 700) return '1_under_700';
                if (h < 800) return '2_700_799';
                if (h < 859) return '3_800_858';
                return '4_859_plus_cta_clears';
            })();


            /* THE ANALYTICS BEHAVIOURAL PIPELINE STARTS ON CONSENT — fixed
               2026-10-03 on the auditor's finding. The previous comment claiming
               these events were "already behind the analytics gate" was false.

               GA4 and Clarity are both loaded inside fmConsent.onAnalytics in
               the template. The event SOURCE was not: this block ran immediately
               on script execution. So for a genuinely fresh visitor — script
               runs, funnel_landed fires, gtag and clarity do not exist yet,
               trackEvent finds no destination and returns, she then accepts, and
               funnel_landed is NEVER fired again. The denominator vanished for
               precisely the first-time, cookie-walled population it exists to
               measure.

               Worse for the one-shot observers: reached_why_90_days,
               view_pricing and cta_view could intersect behind the banner, set
               their fired/disconnect state, transmit nothing, and never fire
               again.

               The earlier dataLayer verification missed it because it ran in a
               profile that ALREADY had consent — it proved the happy path and
               nothing else. Registering the pipeline here means measurement
               begins exactly when it becomes measurable. */
            function startAnalytics() {
            var clarityTagsSet = false;

            function trackEvent(name, params) {
                params = params || {};
                /* Every event carries the arrival viewport, so any of them can be
                   split by "did she meet the obstructed first screen". Set here
                   rather than at each call site so a new event cannot forget it. */
                if (params.initial_viewport_band === undefined) {
                    params.initial_viewport_band = INITIAL_VIEWPORT_BAND;
                }
                if (params.banner_at_load === undefined && BANNER_AT_LOAD !== null) {
                    params.banner_at_load = BANNER_AT_LOAD;
                }
                if (typeof fbq !== 'undefined') {
                    /* Events Shopify's Facebook & Instagram channel ALREADY sends.
                       Firing them here too double-counted them — measured across
                       four dress-rehearsal sessions (batch 49, 2026-08-16). They
                       still go to GA4 below, where there is no second source.

                       THE LIST IS NOW EMPTY, and the mechanism stays anyway:
                       the next event that collides with a Shopify-sent standard
                       event belongs here, and rebuilding the guard under
                       pressure is how double-counting gets reintroduced.

                       add_to_cart LEFT in batch 115 (28 Sep 2026) — by being
                       RENAMED to select_plan. It was suppressed because it
                       shared a name, and therefore a meaning, with the
                       AddToCart that Shopify's channel already sends. Renaming
                       removes the collision at the source: Shopify emits
                       standard events only and cannot emit a custom event
                       called select_plan, so there is nothing left to
                       double-count and Meta gains the mid-funnel signal it was
                       missing.

                       view_pricing LEFT this list in batch 112 (27 Sep 2026).
                       It belonged here only while it was MAPPED to the standard
                       event ViewContent, which Shopify's channel does send — that
                       mapping is gone (metaStandardEvent below now maps
                       email_signup and nothing else), so view_pricing goes as
                       trackCustom('view_pricing'). Shopify's channel sends
                       standard events only and cannot emit a custom event of that
                       name, so there is nothing left to double-count. Suppressing
                       it was costing the one mid-funnel signal Meta had: reached
                       the pricing section. Do not "restore" this without first
                       checking whether the ViewContent mapping has come back —
                       the reason lived in the mapping, not in the event.

                       add_to_cart STAYS. Shopify's channel genuinely sends
                       AddToCart, so that one is still a real duplicate. */
                    const SHOPIFY_OWNS_THESE = [];

                    /* email_signup -> Lead is KEPT deliberately: Shopify does not
                       track this page's email-capture form, so it is the one
                       mapping here that is NOT duplicated. Removing it would drop
                       a real signal rather than remove a phantom one. */
                    const metaStandardEvent = { 'email_signup': 'Lead' }[name];

                    if (SHOPIFY_OWNS_THESE.indexOf(name) === -1) {
                        if (metaStandardEvent) fbq('track', metaStandardEvent, params);
                        else fbq('trackCustom', name, params);
                    }
                }
                if (typeof gtag !== 'undefined') gtag('event', name, params);
                if (typeof ttq !== 'undefined') ttq.track(name, params);

                /* Clarity, added batch 110 (27 Sep 2026). NOT another analytics
                   destination — clarity('set') tags the SESSION, which is what
                   makes recordings filterable by behaviour: "show me the
                   sessions that reached pricing and did not click a plan".
                   Counts tell you people leave; that filter shows you where.

                   Clarity was the only one of the four live trackers this
                   function did not reach, and it is the one that answers "where
                   is the bottleneck" rather than "how many". Value is the most
                   identifying param when there is one (the plan, the FAQ
                   question, the scroll mark), else 'yes'. */
                try {
                    if (typeof clarity !== 'undefined') {
                        var tag = params.percent || params.content_name ||
                                  params.question || params.ingredient || 'yes';
                        clarity('set', name, String(tag));

                        /* AND as a real custom event — added 2026-10-02.

                           set() and event() are NOT interchangeable. set()
                           creates a session TAG: it filters recordings, but it
                           cannot be a funnel step or a smart event. event()
                           creates a first-class Clarity event that can be both.

                           Without this line the only funnel steps this site
                           can offer are page visits and Clarity's four
                           auto-events, and neither reaches past the plan click.

                           MEASURED 2026-10-02, not inferred. Across 470
                           recorded sessions Clarity has never seen a /cart or
                           /checkouts URL, because a plan click leaves
                           fitmiss.co.uk entirely: /cart/{variant}:1 returns 302
                           to Shopify's hosted checkout and frequently on to
                           shop.app, and neither can carry this script on a
                           non-Plus plan. So a URL-based step can never measure
                           checkout here, and Clarity's visibility ends at the
                           plan click.

                           Clarity's own "Begin checkout" auto-event DOES still
                           fire — 8 sessions all-time, detected on-page rather
                           than from a URL — but 0 of them fall in the 7 days
                           covering the £300 burst, so it is a pre-burst
                           artefact. It is the last step of the funnel and it is
                           real; it is simply not a substitute for the on-page
                           events this line enables.

                           Same event name as GA4/Meta deliberately. A
                           sink-specific alias is how two systems quietly start
                           disagreeing about what an event means. */
                        clarity('event', name);

                        /* Session tags for the two arrival facts, set once — added
                           2026-10-03. The auditor called this polish and offered to
                           defer it; deferring is the one thing that does not work,
                           because Clarity tags are NOT retroactive. The moment we
                           actually want them is the £150 gate, when GA4 says
                           "under-700px banner-required visitors progress badly" and
                           the next question is "show me those recordings" — and by
                           then every session that would have answered it is already
                           untagged. Same reasoning that made registering the GA4
                           dimensions before traffic correct.

                           Set here rather than at consent because Clarity loads
                           asynchronously inside the same gate and may not exist yet
                           when startAnalytics runs; by the first event it does. */
                        if (!clarityTagsSet) {
                            clarityTagsSet = true;
                            clarity('set', 'initial_viewport_band', String(INITIAL_VIEWPORT_BAND));
                            if (BANNER_AT_LOAD) clarity('set', 'banner_at_load', String(BANNER_AT_LOAD));
                        }
                    }
                } catch (e) {}
            }

            // exposed so the email form can fire email_signup on success
            window.fmTrack = trackEvent;

            /* Coarse elapsed-time bucket, to accompany the raw ms_since_landing.
               Added 2026-10-02 on the external auditor's correction.

               GA4 exposes a registered custom METRIC as sum / average / count.
               It does NOT give a median, so "store raw ms and take the median
               later" does not work in GA4 reporting — that was stated here as
               though it did. The raw metric still earns its place (averages, and
               a clean export), but the question actually being asked is
               distributional: of the people who reached the offer, how many
               skimmed there and how many spent real time first? A
               low-cardinality bucket answers exactly that, in GA4's own UI, with
               no warehouse and without turning every distinct millisecond into
               its own high-cardinality row.

               Values are prefixed 1_ .. 5_ so GA4 sorts them in TIME order. A
               bare "10_20s" sorts before "5_10s" alphabetically, which silently
               scrambles the distribution the dimension exists to show. */
            /* Viewport band — added 2026-10-03.

               The consent overlay is 403px tall and BOTTOM-anchored, so what a
               visitor can see before dealing with it is (viewportHeight - 403).
               Measured on real paid sessions: 677px (FacebookApp) and 749/763px
               (InstagramApp) all hide the hero CTA, which sits at 402-456 and
               therefore needs a viewport of >=859px to clear. That boundary is
               the whole reason this dimension exists, so the bands straddle it
               rather than being round numbers.

               Nothing in our telemetry could answer "did small-screen visitors
               behave differently" before this. Clarity stores the viewport per
               session, but only one session at a time, by hand — which is how
               those three measurements were taken and is not an analysis.

               Bucketed, not raw: a raw pixel height would be a high-cardinality
               dimension with a row per device, which is exactly the mistake
               avoided with ms_since_landing. */
            /* INITIAL viewport, snapshotted once at load — added 2026-10-03 on the
               auditor's point, and it is not pedantry. Instagram's in-app browser
               resizes constantly as its chrome collapses and expands: one genuine
               paid session logged THIRTEEN "Resized page" events in 49 seconds. So
               a visitor can arrive at 677px, meet the severe cookie-wall version of
               the hero, then scroll with a 740px viewport and be filed under the
               larger band — which answers the opposite of the question we are
               asking. event-time viewport stays as `viewport_band`; this is the one
               that describes the first impression. */
            /* Specific CTA location — was pricing/other, which discarded the
               difference between selecting a plan from the pricing card and
               selecting one after reading the guarantee. At this traffic level
               that is worth a parameter and costs nothing: the six real cart
               links live in pricing (x3), guarantee, start and sticky-cta. */
            function ctaLocation(el) {
                return el.closest('#pricing') ? 'pricing'
                     : el.closest('#guarantee') ? 'guarantee'
                     : el.closest('#start') ? 'start'
                     : el.closest('#sticky-cta') ? 'sticky'
                     : ((el.closest('section') || {}).id || 'other');
            }

            function viewportBand() {
                var h = window.innerHeight || 0;
                if (h < 700) return '1_under_700';
                if (h < 800) return '2_700_799';
                if (h < 859) return '3_800_858';
                return '4_859_plus_cta_clears';
            }

            function elapsedBucket(ms) {
                var s = ms / 1000;
                if (s < 5) return '1_under_5s';
                if (s < 10) return '2_5_10s';
                if (s < 20) return '3_10_20s';
                if (s < 40) return '4_20_40s';
                return '5_over_40s';
            }

            /* FIRED HERE, NOT EARLIER — and the first attempt got this wrong.
               It originally sat just above `window.fmTrack = trackEvent`, which
               is BEFORE `var INITIAL_VIEWPORT_BAND` and `var BANNER_AT_LOAD` are
               assigned. `var` hoists the declaration but not the value, so both
               read `undefined` and the event fired carrying neither of the two
               fields it exists to carry — silently, because `undefined` params
               are simply dropped rather than throwing. Caught by reading the
               event back out of dataLayer instead of trusting the deploy. */
            /* funnel_landed — the DENOMINATOR, added 2026-10-03 on the auditor's
               finding, and the gap was fundamental rather than cosmetic.

               Every behavioural event now carries initial_viewport_band, but a
               visitor who leaves from the hero emits NO event at all. So the
               only question answerable was "among people who went on to do
               something, what viewport did they have" — never "of all
               measurable small-screen landers, how many progressed". The
               missing population is hero exits, which is exactly the population
               a 677px viewport is suspected of harming: the bias pointed
               directly away from the effect being looked for.

               Fires once, immediately, from inside the already-consent-gated
               block. It is a MEASURABLE/CONSENTED landing, not a true arrival —
               anyone who declines or leaves at the wall is still invisible, and
               that limit is permanent (TRACKING.md section 12). */
            /* Now that this runs ON consent rather than on load, its timing is
               not trivia: for a first-time visitor meeting the wall,
               ms_since_landing here is TIME TO GRANT ANALYTICS CONSENT. For a
               returning visitor it is just page-ready. banner_at_load separates
               the two populations. */
            var landedMs = Math.round(performance.now());
            trackEvent('funnel_landed', {
                ms_since_landing: landedMs,
                elapsed_bucket: elapsedBucket(landedMs),
                viewport_band: viewportBand()
            });


            // --- CTA click tracking ---
            /* ONLY REAL CART LINKS FIRE AddToCart — batch 40.

               This used to fall back to sniffing link text and href when data-plan
               was absent: /\b(30-day|90-day|120-day)\b/ AND /(cart|checkout|
               product|plan)/. The hero CTA reads "Start Your 90-Day Plan · £99"
               and points at #pricing — "90-day" matches the first, "plan" matches
               the second, so a click that only SCROLLED TO PRICING fired AddToCart.

               Same for the nav CTA, the mobile-menu CTA and the mid-page link:
               four scroll-to-anchor controls all reporting adds to cart. Meta would
               have optimised against a signal with no purchase intent behind it,
               and it would have looked like healthy volume the whole time.

               data-plan is only ever on real cart links, so the attribute alone is
               the correct selector. The href check is belt and braces in case one
               is ever added to an anchor by mistake. Inference is gone entirely —
               a tracking rule that guesses from copy breaks the next time someone
               edits the copy. */
            document.querySelectorAll('a[data-plan][href^="/cart/"]').forEach(function(link) {
                const plan = link.getAttribute('data-plan');
                const value = plan === '120-day' ? 124 : plan === '30-day' ? 49 : 99;
                link.addEventListener('click', function() {
                    /* select_plan, NOT add_to_cart — renamed batch 115.
                       Two different facts were sharing one name: a click on a
                       plan link is an INTENTION, and Shopify confirming an item
                       entered the cart is a COMMERCE fact. They diverge
                       whenever the cart permalink fails, the user backs out, or
                       Shopify rejects the variant — and while they shared a
                       name that divergence was unmeasurable.
                       Shopify's channel owns AddToCart / InitiateCheckout /
                       Purchase; this page owns the intention that precedes
                       them. */
                    /* ms_since_landing / elapsed_bucket / viewport_band added
                       2026-10-03. This is the moment of commercial intent and it
                       was the ONLY behavioural event carrying no timing, so a
                       click at 8s and a click at 90s were indistinguishable —
                       the exact distinction the buckets exist to draw, missing
                       from the event that matters most. */
                    var planMs = Math.round(performance.now());
                    trackEvent('select_plan', {
                        content_name: plan + ' plan',
                        content_ids: [plan + '-plan'],
                        content_type: 'product',
                        currency: 'GBP',
                        value: value,
                        cta_location: ctaLocation(link),
                        ms_since_landing: planMs,
                        elapsed_bucket: elapsedBucket(planMs),
                        viewport_band: viewportBand()
                    });
                });
            });

            // --- Scroll depth (25/50/75/100%) ---
            const scrollMarks = { 25: false, 50: false, 75: false, 100: false };
            window.addEventListener('scroll', function() {
                const docH = document.documentElement.scrollHeight - window.innerHeight;
                if (docH <= 0) return;
                const pct = Math.round(window.scrollY / docH * 100);
                Object.keys(scrollMarks).forEach(function(mark) {
                    const m = parseInt(mark, 10);
                    if (!scrollMarks[mark] && pct >= m) {
                        scrollMarks[mark] = true;
                        trackEvent('scroll_depth', { percent: m });
                    }
                });
            }, { passive: true });

            // --- Pricing section view (high-intent) ---
            /* OBSERVE THE PRICING HEADING, NOT THE WHOLE SECTION — fixed 2026-10-03.

               This was a silent measurement failure that destroyed the step it
               was built to measure. The observer watched #pricing with
               threshold 0.35, but #pricing is 2,379px tall when the cards stack
               on mobile. The REAL paid viewports are 677px (FacebookApp) and
               749/763px (InstagramApp), so the maximum achievable intersection
               ratio is 28-32% — view_pricing could NEVER fire on the devices the
               whole experiment is about.

               It hid because 844/2379 = 35.5%, just over the line, so a headless
               844px test passed; and because the "is 0.35 reachable" check that
               was supposed to catch it was run in a browser stuck at 1274px wide,
               where the cards sit in three columns and #pricing is only 1,176px.
               The symptom was visible all along — view_pricing in 4 sessions
               against cta_view in 15, which is backwards — and was noted as "odd"
               rather than chased.

               A heading is a few dozen pixels tall, so 0.5 is always reachable
               regardless of viewport, and "the pricing header came into view" is
               a truer definition of entering pricing than "35% of a three-screen
               block is on screen". Found by the external auditor. */
            /* NO FALLBACK TO #pricing — deliberate. An earlier draft read
               `querySelector('#pricing h2') || getElementById('pricing')`, which
               would silently restore the 2,379px target and the exact threshold
               bug this fix exists to remove, the next time someone edits that
               heading. Firing nothing is recoverable; quietly reporting a dead
               step as zero is not. The template preflight
               tools/check_pricing_sentinel.py fails the deploy if the heading
               goes missing, so this cannot pass unnoticed. */
            const pricingSection = document.querySelector('#pricing h2');
            if (pricingSection && 'IntersectionObserver' in window) {
                let pricingViewed = false;
                const io = new IntersectionObserver(function(entries) {
                    entries.forEach(function(entry) {
                        if (entry.isIntersecting && !pricingViewed) {
                            pricingViewed = true;
                            /* Elapsed time added 2026-10-02. "Reached pricing"
                               was the single most-quoted v1 number and it could
                               not distinguish a 4s skim from a 28s read — the
                               exact distinction the auditor's worked example
                               turns on ("40 reached pricing; 22 under 10s"). */
                            var pricingMs = Math.round(performance.now());
                            trackEvent('view_pricing', {
                                content_name: 'Pricing section',
                                content_type: 'product_group',
                                ms_since_landing: pricingMs,
                                elapsed_bucket: elapsedBucket(pricingMs),
                                viewport_band: viewportBand()
                            });
                            io.disconnect();
                        }
                    });
                }, { threshold: 0.5 });
                io.observe(pricingSection);
            }

            /* --- CTA EXPOSURE (cta_view) — TRACKING.md section 9, rank 1 ------

               Built 2026-10-02, after the precommitted £300 stop and before any
               v2 creative: the exact window section 9 reserves for it.

               WHY. v1 ended 73 landings / 0 select_plan, and that zero is
               ambiguous between two diagnoses needing OPPOSITE fixes — nobody
               ever had a plan button on screen (fix the path to the offer), or
               people saw one and refused (fix the proposition). No existing
               event separates them, because every outcome event on this page
               lacks an exposure denominator.

               THE SELECTOR IS a[data-plan][href^="/cart/"] ON PURPOSE: the same
               one select_plan uses, so numerator and denominator are drawn from
               one population. Eight controls here read "Start Your 90-Day Plan"
               and FIVE of them only scroll to #pricing. Counting those as CTA
               exposure would re-create, in the denominator, the exact defect
               batch 40 removed from the numerator — and an inflated denominator
               is worse than no denominator, because it reads as a confident
               "they saw it and refused".

               >=50% visible for >=1s, then fire ONCE per element. Re-firing on
               scroll-back inflates the very denominator this exists to create,
               and a CTA that flashed past mid-flick was not an opportunity to
               buy. The dwell timer is cancelled if the element leaves first.

               ms_since_landing rides along per section 9 rank 2. "Reached a plan
               CTA" is weak alone; reaching one at 4s is a skim and at 28s is a
               considered refusal, and those want different fixes. Section 10
               established it cannot be mined retrospectively — it is emitted
               here or it is lost, exactly as it now is for all of v1. */
            if ('IntersectionObserver' in window) {
                const CTA_DWELL_MS = 1000;
                const CTA_MIN_RATIO = 0.5;
                const ctaTimers = new WeakMap();
                /* GATE ON intersectionRatio, NOT isIntersecting — fixed batch 118
                   on the external auditor's finding.

                   isIntersecting is true for ANY ratio above 0. The first version
                   started the dwell timer on isIntersecting and only cancelled it
                   when the element became completely non-intersecting, so a CTA
                   that crossed 50%, then dropped back to 20% before the second was
                   up, still took the `if (isIntersecting)` branch, found its timer
                   already set, returned — and fired anyway. The code did not
                   enforce the rule its own comment stated, and it failed in the
                   direction that INFLATES the exposure denominator, which is the
                   one thing this event exists not to do.

                   thresholds are [0, 0.5, 1] rather than a lone 0.5 so the
                   observer is actually called on the way back down. With a single
                   threshold the callback only fires at that one boundary, which is
                   too thin to cancel reliably during a fast flick.

                   The 1e-6 is float tolerance: a browser may report 0.4999999 for
                   an element sitting exactly on the threshold, and dropping a
                   legitimate exposure is as wrong as inventing one. */
                const ctaObserver = new IntersectionObserver(function(entries) {
                    entries.forEach(function(entry) {
                        const el = entry.target;
                        if (entry.isIntersecting && entry.intersectionRatio + 1e-6 >= CTA_MIN_RATIO) {
                            if (ctaTimers.has(el)) return;
                            ctaTimers.set(el, setTimeout(function() {
                                ctaObserver.unobserve(el);
                                const plan = el.getAttribute('data-plan');
                                const ctaMs = Math.round(performance.now());
                                trackEvent('cta_view', {
                                    content_name: plan + ' plan',
                                    content_ids: [plan + '-plan'],
                                    cta_location: ctaLocation(el),
                                    ms_since_landing: ctaMs,
                                    elapsed_bucket: elapsedBucket(ctaMs),
                                    viewport_band: viewportBand()
                                });
                            }, CTA_DWELL_MS));
                        } else if (ctaTimers.has(el)) {
                            clearTimeout(ctaTimers.get(el));
                            ctaTimers.delete(el);
                        }
                    });
                }, { threshold: [0, CTA_MIN_RATIO, 1] });
                document.querySelectorAll('a[data-plan][href^="/cart/"]')
                        .forEach(function(el) { ctaObserver.observe(el); });
            }

            /* --- jump-to-pricing CTA clicks, and the two arguments before pricing ---
               Both added 2026-10-03 on the auditor's recommendation.

               pricing_cta_click: select_plan deliberately fires ONLY on real
               /cart/ links, which is right — but that leaves the hero button v2
               exists to improve completely unmeasured, because it is an anchor to
               #pricing. This separates "she ASKED to see the plans" from "she
               happened to scroll into them", which for judging the H6 hero change
               is close to the most useful signal available.

               reached_why_90_days / reached_coach: the only two arguments between
               the hero and pricing. Named sections were skipped earlier as
               telemetry maximalism; the auditor's counter is better — LOW traffic
               is a reason to make each session more informative, and 25/50/75%
               scroll buckets are page-relative, so they say how far someone got
               but never which argument they reached. Two fire-once milestones is
               a diagnostic funnel, not instrumenting every div. Headings are the
               targets for the same reason as the view_pricing fix: a small element
               is reachable at any viewport. */
            document.querySelectorAll('a[href="#pricing"]').forEach(function(a) {
                a.addEventListener('click', function() {
                    const loc = this.closest('#mobile-menu') ? 'mobile_menu'
                              : this.closest('#hero-ctas') ? 'hero'
                              : this.closest('#hero') ? 'hero_secondary'
                              : this.closest('#header') ? 'nav'
                              : ((this.closest('section') || {}).id || 'midpage');
                    trackEvent('pricing_cta_click', { cta_location: loc,
                                                      ms_since_landing: Math.round(performance.now()),
                                                      elapsed_bucket: elapsedBucket(Math.round(performance.now())),
                                                      viewport_band: viewportBand() });
                });
            });

            if ('IntersectionObserver' in window) {
                [['#why-90-days h2', 'reached_why_90_days'],
                 ['#coach h2', 'reached_coach']].forEach(function(pair) {
                    const el = document.querySelector(pair[0]);
                    if (!el) return;
                    let fired = false;
                    const so = new IntersectionObserver(function(entries) {
                        entries.forEach(function(entry) {
                            if (entry.isIntersecting && !fired) {
                                fired = true;
                                so.disconnect();
                                const ms = Math.round(performance.now());
                                trackEvent(pair[1], { ms_since_landing: ms,
                                                      elapsed_bucket: elapsedBucket(ms),
                                                      viewport_band: viewportBand() });
                            }
                        });
                    }, { threshold: 0.5 });
                    so.observe(el);
                });
            }

            // --- Accordion engagement ---
            document.querySelectorAll('[onclick*="toggleAccordion"]').forEach(function(btn) {
                btn.addEventListener('click', function() {
                    const label = (this.textContent || '').trim().split('\n')[0].slice(0, 80);
                    if (this.closest('#faq')) trackEvent('expand_faq', { question: label });
                    else if (this.closest('#ingredients')) trackEvent('expand_ingredient', { ingredient: label });
                });
            });

            // --- Email signup ---
            const emailForm = document.querySelector('#email-capture form');
            /* NO email_signup ON SUBMIT — batch 40.

               A listener here fired email_signup (Meta "Lead") on every submit,
               while handleEmailSubmit ALSO fires it via window.fmTrack inside the
               Klaviyo success branch. Two consequences, both bad:

                 - a successful signup sent Lead TWICE
                 - a FAILED signup still sent Lead once, including today, where
                   COMPANY_ID is blank and every submission ends on "Signup is
                   opening soon"

               So the current state of the page would report a 100% lead rate on a
               form that cannot succeed. Removed; the success-branch call is the
               only one, which is where a Lead is actually true. */
            }

            if (window.fmConsent && typeof window.fmConsent.onAnalytics === 'function') {
                window.fmConsent.onAnalytics(startAnalytics);
            }
        })();
    

/* ==== iOS :active press states ==== */
    // Enables CSS :active press states on iOS Safari (requires a touch listener to exist)
    document.addEventListener('touchstart', function () {}, { passive: true });
    // iOS Safari applies :focus-visible rings on taps; release focus after touch on non-input controls
    document.addEventListener('touchend', function (e) {
        var t = e.target && e.target.closest ? e.target.closest('a, button') : null;
        if (t) setTimeout(function () { t.blur(); }, 0);
    }, { passive: true });

    /* Pill-fade JS removed 2026-08-18 with #hero-pills. It self-guarded on the
       missing element so it was inert either way. The .hero-pill-scroll CSS
       rules are deliberately kept — cheap, and they are the thing to restore
       if the chips ever come back. */
    

/* ==== Klarna on-site-messaging line height sync ==== */
    (function () {
        var line = document.querySelector('.klarna-line');
        if (!line) return;
        function sync() { line.classList.toggle('k-live', line.offsetHeight > 4); }
        sync();
        if ('ResizeObserver' in window) {
            line.__kro = new ResizeObserver(sync);
            line.__kro.observe(line);
        }
        setInterval(sync, 1000);
        window.addEventListener('load', sync);
    })();
    

/* ==== attribution carry-through — batch 111, 27 Sep 2026 ====
 *
 * THE PROBLEM. The ad link already carries
 * utm_content={{ad.name}} (Meta substitutes the real ad name), and Shopify's
 * own customerJourneySummary records first/last visit UTMs on the order. What
 * breaks is everything AFTER the order: the members webhook stores no
 * attribution at all, and a Clarity session cannot be tied to an order, so the
 * stream is four disconnected pools rather than one story per person.
 *
 * WHAT THIS ADDS. A first-party visitor id (fm_vid) and FIRST-TOUCH attribution,
 * carried into the Shopify order as cart attributes, and stamped onto the
 * Clarity session as tags. That makes these possible for the first time:
 *   - filter Clarity recordings BY AD ("show me sessions from FM-ABIGAIL-HACK")
 *   - join a Clarity session to the order it produced, via fm_vid
 *   - give the members app the ad that sold each customer (webhook change,
 *     separate commit) so retention can be read per creative
 *
 * FIRST touch, not last: the value is "which ad introduced this person", and
 * that is destroyed by a later direct visit. Never overwritten once set.
 *
 * Cart attributes are a documented cart-permalink feature
 * (shopify.dev/docs/apps/build/checkout/create-cart-permalinks step 6) and land
 * in the Notes section of the order.
 *
 * CONSENT: the MARKETING purpose, not analytics (purpose split 2026-09-28).
 * Shopify defines marketing as covering "marketing, attribution and targeted
 * advertising", and first-touch ad attribution is squarely that. GA4 and
 * Clarity run on the ANALYTICS purpose instead, so a visitor who allows
 * analytics but declines marketing is still measured behaviourally and is
 * simply never attributed to an ad — which is the correct outcome, not a gap.
 * Declining marketing means no id, no tags and no cart attributes. Nothing is
 * stored beforehand.
 */
(function () {
    if (!window.fmConsent || typeof window.fmConsent.onMarketing !== 'function') return;

    window.fmConsent.onMarketing(function () {
        var KEY = 'fm_attr_v1';
        var store = null;
        try { store = window.localStorage; } catch (e) { return; }  /* private mode: skip silently */

        function read() {
            try { return JSON.parse(store.getItem(KEY) || 'null'); } catch (e) { return null; }
        }

        var attr = read();
        if (!attr) {
            var q = new URLSearchParams(window.location.search);
            /* crypto.randomUUID is not available on older in-app browsers, and
               Facebook/Instagram webviews are most of this page's paid traffic,
               so fall back rather than throw. */
            var vid;
            try { vid = crypto.randomUUID(); }
            catch (e) { vid = 'v' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10); }
            attr = {
                vid: vid,
                src: q.get('utm_source') || '',
                med: q.get('utm_medium') || '',
                cmp: q.get('utm_campaign') || '',
                ad: q.get('utm_content') || '',
                fbclid: q.get('fbclid') ? '1' : '',   /* presence only — the id itself is Meta's to hold */
                ts: new Date().toISOString().slice(0, 10),
                /* Batch 113. Meta substitutes these at click time, the same way
                   it already substitutes {{ad.name}} into utm_content.
                     adset  — the AUDIENCE. Which targeting found her.
                     plc    — the PLACEMENT (Reels / Feed / Stories / Explore).
                              Usually a bigger performance swing than creative,
                              and the dimension that decides where scale-up money
                              goes. Meta reports it, but only against purchases
                              Meta can see; carrying it here is what lets it be
                              joined to RETENTION months later.
                     plat   — {{site_source_name}}: fb / ig / an / msg. Kept
                              separate from utm_source deliberately — the
                              orchestrator's _is_meta_paid() matches utm_source
                              against a fixed set, and 'an' (Audience Network)
                              is not in it, so repurposing utm_source would have
                              silently dropped those orders from Meta CAC.
                     adid   — {{ad.id}}. Names get edited; ids do not. This is
                              the stable join key when a creative is renamed. */
                adset: q.get('utm_term') || '',
                plc: q.get('fm_placement') || '',
                plat: q.get('fm_platform') || '',
                adid: q.get('fm_adid') || ''
            };
            try { store.setItem(KEY, JSON.stringify(attr)); } catch (e) { /* quota/blocked: carry in-memory */ }
        }

        /* Clarity session tags. This is the point of the whole block: Clarity
           recordings become filterable by ad, and fm_vid joins a session to the
           order it produced. */
        try {
            if (typeof clarity !== 'undefined') {
                clarity('set', 'fm_vid', attr.vid);
                if (attr.ad) clarity('set', 'fm_ad', attr.ad);
                if (attr.cmp) clarity('set', 'fm_campaign', attr.cmp);
                clarity('set', 'fm_source', attr.src || 'direct');
                /* Placement earns a tag of its own: "show me the Reels
                   sessions that reached pricing and did not click a plan" is a
                   question worth being able to ask directly. */
                if (attr.plc) clarity('set', 'fm_placement', attr.plc);
                if (attr.adset) clarity('set', 'fm_adset', attr.adset);
            }
        } catch (e) {}

        /* Stamp the real cart links so the attributes reach the order. Only
           a[data-plan][href^="/cart/"] — the same selector add_to_cart uses, and
           for the same reason: scroll-to-anchor CTAs are not purchases. */
        var pairs = [['fm_vid', attr.vid], ['fm_ad', attr.ad], ['fm_campaign', attr.cmp],
                     ['fm_source', attr.src], ['fm_medium', attr.med],
                     ['fm_adset', attr.adset], ['fm_placement', attr.plc],
                     ['fm_platform', attr.plat], ['fm_adid', attr.adid]];
        var qs = pairs
            .filter(function (p) { return p[1]; })
            .map(function (p) { return 'attributes[' + p[0] + ']=' + encodeURIComponent(p[1]); })
            .join('&');
        if (!qs) return;
        document.querySelectorAll('a[data-plan][href^="/cart/"]').forEach(function (a) {
            var href = a.getAttribute('href') || '';
            if (href.indexOf('attributes[fm_vid]') !== -1) return;   /* idempotent */
            a.setAttribute('href', href + (href.indexOf('?') === -1 ? '?' : '&') + qs);
        });
    });
})();
